import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgDropperGlyphSecondary from './svgs/DropperGlyphSecondary.js';
import SvgDropperGlyph from './svgs/DropperGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var dropperGlyph = (props => useIcon(SvgDropperGlyph, SvgDropperGlyphSecondary, props));

export { dropperGlyph as default };
